import {
	Component,
	ContentChild,
	EventEmitter,
	Input,
	Output,
	TemplateRef
}                        from '@angular/core';
import { BaseComponent } from '@core/bases/base-component/base.component';
import {
	ActionDisplayModeEnum,
	ActionIconSizeEnum
}                        from '@shared/components/action-item/action-item.enum';
import {
	IStatusFlow,
	IStatusFlowAction,
	IStatusFlowAllAction,
	IStatusFlowChangeEvent,
	OutOfFlowDisplayModeEnum
}                        from '@shared/components/status-flow/status-flow.model';

@Component( {
	selector: 'app-status-flow[currentState][statusFlow]',
	templateUrl: './status-flow.component.html',
	styleUrls: [ './status-flow.component.scss' ]
} )
export class StatusFlowComponent extends BaseComponent {

	private _currentState: any;
	private _outOfFlowDisplayModeEnum = OutOfFlowDisplayModeEnum;
	private _statusFlow: IStatusFlow<any, any>;
	statusFlowActions: IStatusFlowAllAction<any, any>[] = [];

	@Input() displayMode: ActionDisplayModeEnum = ActionDisplayModeEnum.Standalone;
	@Input() actionIconSize: ActionIconSizeEnum;
	@Input() showTooltip: boolean;
	@Input() enforceCustomTemplate: boolean;

	@Input() set currentState( currentState: any ) {
		this._currentState = currentState;
		this.init();
	}

	@Input() set statusFlow( statusFlow: IStatusFlow<any, any> ) {
		this._statusFlow = statusFlow;
		this.init();
	}

	@Output() clickEvent: EventEmitter<IStatusFlowChangeEvent<any>> = new EventEmitter<IStatusFlowChangeEvent<any>>();

	@ContentChild( 'actionItemTplRef', { read: TemplateRef } ) actionItemTplRef: TemplateRef<any>;

	private init(): void {
		if ( !this._statusFlow || !this._currentState ) { return; }

		this.statusFlowActions =
			this._statusFlow.actions.sort( ( statusActionA: IStatusFlowAction<any, any>, statusActionB: IStatusFlowAction<any, any> ) =>
				statusActionA.order > statusActionB.order ? 1 : -1
			)
			.map( ( statusAction: IStatusFlowAction<any, any> ) => {
				return {
					...statusAction,
					isDisabled: this.disableActionItem( statusAction ),
					isHidden: this.hideActionItem( statusAction ),
					isRendered: true
				};
			} );
	}

	private hideActionItem( statusAction: IStatusFlowAction<any, any> ): boolean {

		// check currentStatus equals targetStatus
		if ( this._currentState === statusAction.targetStatus ) {
			return true;
		}

		// check enforce hide on status
		if ( statusAction.enforceHideOnStatuses?.includes( this._currentState ) ) {
			return true;
		}

		// check outOfFlow status
		if (
			statusAction.outOfFlowDisplayMode === this._outOfFlowDisplayModeEnum.HIDDEN &&
			!this._statusFlow.flow[ this._currentState ]?.includes( statusAction.targetStatus )
		) {
			return true;
		}

		return false;
	}

	private disableActionItem( statusAction: IStatusFlowAction<any, any> ): boolean {

		// check statusFlow
		if ( !this._statusFlow.flow[ this._currentState ]?.includes( statusAction.targetStatus ) ) {
			return true;
		}

		// check enforceDisableOnStatuses
		if ( statusAction.enforceDisableOnStatuses?.includes( this._currentState ) ) {
			return true;
		}

		return false;
	}

	changeStatus( statusAction: IStatusFlowAction<any, any> ): void {
		if ( this._statusFlow.flow[ this._currentState ]?.includes( statusAction.targetStatus ) ) {
			this.clickEvent.emit(
				{
					targetStatus: statusAction.targetStatus,
					dialog: statusAction?.dialog,
					requestActionStatus: statusAction?.requestActionStatus
				}
			);
		}
	}
}
